<div class="container-fluid" [ngStyle]="{'direction': currLang == 'en' ? 'ltr' : 'rtl'}" id="selectModal">

    <div class="row " class='header-title-wrapper' [ngStyle]="{'text-align': currLang == 'en' ? 'left' : 'right'}">
        <div>
            {{'messages.select-users-manulally.title' | translate}}

            <button type="button" class="close " (click)="onNoClick()" [ngClass]="(currLang == 'en') ? 'float-right' : 'float-left' ">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>

    <div class="row" >
        <div class="col-3 filter-wrapper">
            <app-sidebar-filter (onCheckBoxClicked)="handleCheckedList($event)" [roles]='data.rolesArray'>
            </app-sidebar-filter>
        </div>

        <div class="col-9 filterAndTableWrapper">
            <div class='row'>
                <div class="col-9">
                    <app-controller-bar (onViewTypeChange)='changeView($event)' (messagesSearchChange)="searchChanged($event)"></app-controller-bar>
                </div>
                <div class="col-3 d-flex justify-content-end align-items-center">
                    <button class='btn btn-primary' [disabled]='selectedUsersIds.length < 1'
                        (click)='setRecepientsIds()'> {{'messages.select-users-manulally.add-recepients' | translate}}</button>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <app-table-view [showPaginatian]='false' (eventHandeler)='checkboxesHandler($event)'
                        [controls]="data.tableControls" [selectedUsersIDS]="selectedUsersIds"
                        [currentView]='currentView'
                        [showSideBar]="false"> 
                    </app-table-view>
                </div>
            </div>
        </div>
    </div>






</div>